import './MithraTableHeadColumns.scss';
import type {CSSProperties} from "react";
import React from "react";
import {LinearProgress, TableCell, TableHead, TableRow, TableSortLabel} from "@mui/material";
import {useStores} from "../../stores";
import {observer} from "mobx-react-lite";
import {AdminPanelSettings} from "@mui/icons-material";

export type ColSpec = {
    txt: string
    cls?: string
    align?: 'right' | 'center'
    minWidth?: number
    width?: number
    /**
     * Only used for identifying which fields has an active ordering
     */
    columnFieldId?: string
    /**
     * Will overwrite the width and minWidth
     */
    style?: CSSProperties
    /**
     * In case we want to add this column with the customized name to the filters, but not in the table
     */
    hideInTable?: boolean
    /**
     * Column only visible for Mithra staff
     */
    isMithraStaffOnly?: boolean
};
export type ExtendedColSpec = ColSpec | ColSpec & {
    txt: React.ReactNode
}

type Props = {
    columns: ExtendedColSpec[]
    enableLoading?: boolean
    isLoading?: boolean
    orderBy?: ColSpec['columnFieldId']
    orderDirection?: 'asc' | 'desc'
    onClickOrdering?: (c: ColSpec) => void
};
export const MithraTableHeadColumns: React.FC<Props> = observer(
    ({
         columns,
         enableLoading,
         isLoading,
         orderBy,
         orderDirection,
         onClickOrdering
     }) => {
        const {p, authStore} = useStores();
        return <TableHead>
            <TableRow>
                {columns.map((c, i) => {
                    const isSortable = p.isColumnSortable(c.columnFieldId)
                    return <TableCell
                        key={i}
                        className={(c.cls ?? '') + (isSortable ? ' sortable' : '')}
                        align={c.align}
                        style={c.style || {width: c.width, minWidth: c.minWidth}}>
                        {authStore.isMithraStaffGroup && c.isMithraStaffOnly &&
                            <AdminPanelSettings/>
                        }
                        {isSortable
                            ? <TableSortLabel
                                onClick={() => onClickOrdering ? onClickOrdering(c) : undefined}
                                active={c.columnFieldId === orderBy}
                                direction={orderDirection}>
                                {c.txt}
                            </TableSortLabel>
                            : c.txt
                        }
                        {authStore.isMithraStaffGroup && c.columnFieldId &&
                            <div className="mithra-table-cell-dev"><span>{c.columnFieldId}</span></div>
                        }
                    </TableCell>;
                })}
            </TableRow>
            {enableLoading && <tr className={'progress-row' + (isLoading ? ' loading' : '')}>
                <td colSpan={columns.length}>
                    {isLoading && <LinearProgress variant="indeterminate"/>}
                </td>
            </tr>}
        </TableHead>;
    })